import domReady from '../../js/dom-ready.js';
import elmntIO from '../../js/elmnt-io.js';

domReady(function() {
    const $countNumbers = document.querySelectorAll('.wp-block-nn-counter .count-number');

    $countNumbers?.forEach($countNumber => {
        elmntIO($countNumber, () => {
            callbackEnter($countNumber);
        });
    });
});


function callbackEnter($el) {
    const dataCount = ($el.dataset.count) ? $el.dataset.count : null;
    $el.innerHTML = '0';

    if ( !dataCount ) {
        return;
    }

    let currentCount = 0;
    const counterIntval = setInterval(() => {
        if ( dataCount > currentCount ) {
            const randNumMutliplier = Math.ceil(dataCount * 0.045);
            let randNum = Math.ceil(Math.random() * randNumMutliplier);
            currentCount = currentCount + randNum;
            $el.innerHTML = currentCount.toLocaleString();
        } else {
            clearInterval(counterIntval);
            $el.innerHTML = parseInt(dataCount).toLocaleString();
        }
    }, 50);
}